export default __webpack_public_path__ + "static/white-grid-5b2b5156aa2963963f43511e5415aab3.svg";